"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NewPasswordSubmits = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var password_1 = require("../../model/password");
var service_1 = require("../../../library/base/service");
var NewPasswordSubmits = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(NewPasswordSubmits, _super);
    function NewPasswordSubmits() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '客户修改交易密码';
        _this.code = '101015';
        _this.desc = '客户修改交易密码';
        _this.requestParams = new password_1.NewPasswordSubmitsRequest();
        _this.method = fetch_1.Methods.POST;
        return _this;
    }
    return NewPasswordSubmits;
}(service_1.BaseService));
exports.NewPasswordSubmits = NewPasswordSubmits;
//# sourceMappingURL=newPasswordSubmits.js.map